import HomeIcon from "@mui/icons-material/HomeRounded";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Breadcrumbs, Chip, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import { translate } from "../app/utils";

// Styled breadcrumb chip
const StyledBreadcrumb = styled(Chip)(({ theme }) => ({
  borderRadius: 4,
  backgroundColor: "transparent",
  marginTop: 5,
  height: theme.spacing(3.5),
  color: theme.palette.text.primary,
  fontWeight: 500,
  cursor: "pointer",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  maxWidth: 200,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",

  "&:hover, &:focus": {
    backgroundColor: "transparent",
    color: theme.palette.text.primary,
    textDecoration: "underline",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "transparent",
  },
}));

const BreadCrumbs = () => {
  const { pathname } = useLocation();

  const breadcrumbsMapping = {
    "/": "Home",
    "/users": "Users",
    "/roles": "Roles",
    "/resources": "Resources",
    "/configurations": "System Configurations",
    "/uploads": "Uploads",
    "/authors": "Authors",
    "/languages": "Languages",
    "/books": "Books",
    "/books/details": "Book Details",
    "/404": "Page Not Found",
  };

  const pathnames = pathname.split("/").filter((x) => x);

  return (
    <Grid
      container
      sx={{
        display: "flex",
        alignItems: "center",
        marginTop: "20px",
        padding: "0 16px",
        overflowX: "auto",
        flexWrap: "wrap",
      }}
    >
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={
          <NavigateNextIcon fontSize="small" sx={{ color: "text.disabled" }} />
        }
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          overflow: "auto",
          whiteSpace: "nowrap",
          width: "100%",
        }}
      >
        {pathname !== "/" && (
          <StyledBreadcrumb
            key="breadCrumb-home"
            component="a"
            href="/"
            label={translate("home")}
            icon={<HomeIcon fontSize="small" />}
          />
        )}
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          const translated = breadcrumbsMapping[to] || translate(value);

          return last ? (
            <StyledBreadcrumb
              key={`breadCrumb-${index}`}
              label={translated}
              sx={{
                color: "text.primary",
                fontWeight: "bold",
                backgroundColor: "transparent",
              }}
            />
          ) : (
            <StyledBreadcrumb
              key={`breadCrumb-${index}`}
              component="a"
              href={to}
              label={translated}
            />
          );
        })}
      </Breadcrumbs>
    </Grid>
  );
};

export default BreadCrumbs;
